import { render, staticRenderFns } from "./ResalesShipping.vue?vue&type=template&id=fe7ebcd0"
import script from "./ResalesShipping.vue?vue&type=script&lang=js"
export * from "./ResalesShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports